import styled from 'styled-components';

export const BrandingContainer = styled.div`
  width: 100%;
  padding: 10px 25px;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  z-index: 1000;

  .footer {
    justify-content: end;
  }
`;
